import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DataTable } from '@/shared/components/data-table';
import type { EquipmentModelRow } from '../types';
import type { EquipmentColumnDef, EquipmentRenderContext } from '../hooks/useEquipmentListTable';

interface EquipmentListViewProps {
  sortedItems: EquipmentModelRow[];
  visibleColumns: EquipmentColumnDef[];
  columnFilters: Record<string, string>;
  ctx: EquipmentRenderContext;
  sortKey: string;
  sortDirection: 1 | -1;
  isLoading?: boolean;
  emptyLabel: string;
  onSort: (key: string) => void;
  onSetColumnFilter: (key: string, value: string) => void;
  onSelectItem: (item: EquipmentModelRow) => void;
  onCreateItem?: () => void;
}

/** Presentational wrapper over the shared <DataTable>; table state lives in useEquipmentListTable. */
export function EquipmentListView({
  sortedItems,
  visibleColumns,
  columnFilters,
  ctx,
  sortKey,
  sortDirection,
  isLoading,
  emptyLabel,
  onSort,
  onSetColumnFilter,
  onSelectItem,
  onCreateItem,
}: EquipmentListViewProps) {
  return (
    <DataTable<EquipmentModelRow, EquipmentRenderContext>
      items={sortedItems}
      columns={visibleColumns}
      ctx={ctx}
      columnFilters={columnFilters}
      sortKey={sortKey}
      sortDirection={sortDirection}
      isLoading={isLoading}
      onSort={onSort}
      onSetColumnFilter={onSetColumnFilter}
      onRowClick={onSelectItem}
      getRowKey={(item) => item.id}
      emptyState={(
        <>
          {emptyLabel}{' '}
          {onCreateItem && (
            <Button variant="link" size="sm" onClick={onCreateItem}>
              <Plus className="h-4 w-4 mr-1" /> Add model
            </Button>
          )}
        </>
      )}
    />
  );
}
